<template>
    <div>
        <el-dialog :before-close="handleDialogClose"
                   :class="{ 'custom-dialog-no-footer': type == 'look' || type == 'readonly' }"
                   :close-on-click-modal="false"
                   :visible.sync="confirmMemberDialogVisible"
                   class="custom_form_dialog custom-form-dialog personnel_form_dialog"
                   title=""
                   width="560px">
            <template #title>
                <div class="avatar_name_wrap">
                    <img :src="userDetails.header_img ||'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'"
                         alt=""
                         class="header_img"/>
                    <div>
                        <p class="user_name">
                            {{
                                userDetails.name
                            }}<span :class="'tag-label-' + type" class="tag-label">{{ getTagLable }} </span>
                        </p>
                        <p>
                            <span>{{ userDetails.did_name }}</span>
                        </p>
                    </div>
                </div>
            </template>
            <span slot="footer" class="dialog-footer">
                <template v-if="type == 'confirm'">
                    <el-button type="primary" @click.stop="handleClickConfirmProfile">信息确认</el-button>
                </template>
                <template v-else-if="type == 'unregistered'">
                    <el-button type="primary" @click.stop="handleClickCancelAdd">取消添加</el-button>
                </template>
                <template v-else-if="type == 'PendingJoin'">
                    <el-button @click.stop="handleClickCancelEntry">取消入职</el-button>
                    <el-button type="primary" @click.stop="handleClickConfirmEntry">确认入职</el-button>
                </template>
                <template v-else-if="type == 'pendingOffice'">
                    <el-button @click.stop="handleClickCancelQuit">取消离职</el-button>
                    <el-button type="primary" @click.stop="handleClickConfirmQuit">确认离职</el-button>
                </template>
            </span>
            <div class="custom_form_body">
                <p v-if="type == 'unregistered'" class="dialog-txt-tip">
                    该员工未注册澜精灵账号，请发送登录链接给员工，您也可以
                    <el-button
                            :disabled="isSendSms"
                            class="link-label_btn"
                            type="text"
                            @click="handleClickSend"
                    >发送短信
                    </el-button
                    >
                    通知对方
                </p>
                <p class="dialog-txt-tip" v-if="type == 'PendingJoin'">
                    该员工已填写入职信息，请核实信息无误后，操作【确认入职】加入公司
                </p>
                <p class="dialog-txt-tip" v-if="type == 'pendingOffice'">
                    该员工已办理离职，请确认工作交接无误后，操作确认离职
                </p>
                <CustomFormDetailPc
                        v-if="dataLoaded"
                        ref="customFormPc"
                        :field_list="formInfoList"
                        :form_detail="formData"
                        :is_edit_mode="hasEditPermission"
                        :pk_id="user_id"
                        @submit-form="summitFormData"
                />
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
    import {
        editUser,
        getFormFields,
        getUserDetail,
        SendLoginSMS,
        confirmQuit,
        cancelQuit,
        confirmEntry,
        cancelEntry,
        UpdateProfileEdit,
        GetUserProfileEdits,
        ConfirmProfileEdit,
    } from "@/api";
    import {mapGetters} from "vuex";
    export default {
        name: "confirmMember",
        props: {
            confirmMemberDialogVisible: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: "look",
            },
            user_id: {
                type: Number,
                default: 0,
            },
            profile_edit: {
                type: Boolean,
                default: false,
            }, // 是否邀请之后编辑过的
        },
        data() {
            return {
                dialogTitle: "编辑信息",
                didTitle: "",
                userDetails: {
                    header_img: "",
                    name: "",
                    did_name: "",
                },
                formData: {},
                formInfoList: [],
                dataLoaded: false,
                isSendSms: false, // 是否发送了短信 每次只能发送一次，再次进来这个页面还可以操作，避免无限点击
                edit_id: "",
            };
        },
        components: {CustomFormDetailPc},
        computed: {
            getTagLable() {
                let label = "";
                switch (this.type) {
                    case "unregistered":
                        label = "未注册";
                        break;
                    case "PendingJoin":
                        label = "待入职";
                        break;
                    case "pendingOffice":
                        label = "待离职";
                        break;
                    default:
                        label = "";
                        break;
                }
                return label;
            },
            ...mapGetters(['hasPermission']),
            hasEditPermission() {
                return this.hasPermission('person.userEdit', 'person', 'DepartmentPersonnel');
            },
        },
        created() {
            this._getFromFields();
        },
        methods: {
            _getFromFields() {
                this.loading = true;
                getFormFields({
                    field_form: "users",
                })
                        .then((res) => {
                            if (res.code === 200) {
                                this.formInfoList = res.data;
                                if (this.user_id) {
                                    if (this.profile_edit) {
                                        // 被邀请之后 编辑过的
                                        GetUserProfileEdits({
                                            user_id: this.user_id,
                                        }).then((res) => {
                                            if (res.code === 200) {
                                                // edit_id编辑的时候用
                                                this.edit_id = res.data.id;
                                                // 如果编辑过 就用最新编辑的数据，否则使用最开始的数据
                                                let data = res.data.edited_data ? res.data.edited_data : res.data.original_data;
                                                this.formData = data;
                                                this.userDetails.header_img = data.avatar;
                                                this.userDetails.name = data.name.value;
                                                this.userDetails.did_name =
                                                        data.department_id.text && data.department_id.text.length
                                                                ? data.department_id.text[0].full_path
                                                                : "";
                                                this.dataLoaded = true;
                                            } else {
                                                this.$message.error(res.message);
                                            }
                                        });
                                    } else {
                                        getUserDetail({
                                            user_id: this.user_id,
                                        }).then((res) => {
                                            if (res.code === 200) {
                                                this.formData = res.data;
                                                this.userDetails.header_img = res.data.avatar;
                                                this.userDetails.name = res.data.name.value;
                                                this.userDetails.did_name =
                                                        res.data.department_id.text && res.data.department_id.text.length
                                                                ? res.data.department_id.text[0].full_path
                                                                : "";
                                                this.dataLoaded = true;
                                            } else {
                                                this.$message.error(res.message);
                                            }
                                        });
                                    }
                                }
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
            },

            handleDialogClose() {
                this.$emit("update:confirmMemberDialogVisible", false);
            },

            // 取消添加
            handleClickCancelAdd(row) {
                const h = this.$createElement;
                this.$msgbox({
                    title: "取消添加",
                    message: h("div", null, [h("span", null, "取消添加后，如需再次加入公司需重新邀请或新增员工。")]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                    customClass: "prompt_message_custom",
                    confirmButtonText: "确定",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass: "",
                    showClose: false,
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            done();
                        } else {
                            done();
                        }
                    },
                })
                        .then(() => {
                            let postData = {
                                user_id: this.user_id,
                            };
                            this.loading = true;
                            cancelEntry(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message.success("操作成功");
                                    this.handleDialogClose()
                                    this.$emit("success-callback");
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {
                        });
            },
            // 确认入职
            handleClickConfirmEntry() {
                const h = this.$createElement;
                this.$msgbox({
                    title: "确认入职",
                    message: h("div", null, [h("span", null, "确认入职后，该员工加入公司，账号立即生效！ ")]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: "prompt_message_custom",
                    confirmButtonText: "确定",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass: "",
                    showClose: false,
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            done();
                        } else {
                            done();
                        }
                    },
                })
                        .then(() => {
                            let postData = {
                                user_id: this.user_id,
                            };
                            this.loading = true;
                            confirmEntry(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message.success("操作成功");
                                    this.$emit("success-callback");
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {
                        });
            },
            // 取消入职
            handleClickCancelEntry() {
                const h = this.$createElement;
                this.$msgbox({
                    title: "取消入职",
                    message: h("div", null, [h("span", null, "取消入职后，如需再次加入公司需重新邀请或新增员工。 ")]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                    customClass: "prompt_message_custom",
                    confirmButtonText: "确定",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass: "",
                    showClose: false,
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            done();
                        } else {
                            done();
                        }
                    },
                })
                        .then(() => {
                            let postData = {
                                user_id: this.user_id,
                            };
                            this.loading = true;
                            cancelEntry(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message.success("操作成功");
                                    this.handleDialogClose()
                                    this.$emit("success-callback");
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {
                        });
            },
            // 确认离职
            handleClickConfirmQuit() {
                const h = this.$createElement;
                this.$msgbox({
                    title: "确认离职",
                    message: h("div", null, [
                        h("span", null, "确认离职后，该员工的帐号将关闭，请确保工作交接已完成！！！"),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: "prompt_message_custom",
                    confirmButtonText: "确定",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass: "",
                    showClose: false,
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            done();
                        } else {
                            done();
                        }
                    },
                })
                        .then(() => {
                            let postData = {
                                user_id: this.user_id,
                            };
                            this.loading = true;
                            confirmQuit(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message.success("操作成功");
                                    this.$emit("success-callback");
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {
                        });
            },
            // 取消离职
            handleClickCancelQuit() {
                const h = this.$createElement;
                this.$msgbox({
                    title: "取消离职",
                    message: h("div", null, [h("span", null, "取消离职后，该员工将恢复为正常在职状态。")]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                    customClass: "prompt_message_custom",
                    confirmButtonText: "确定",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass: "",
                    showClose: false,
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            done();
                        } else {
                            done();
                        }
                    },
                })
                        .then(() => {
                            let postData = {
                                user_id: this.user_id,
                            };
                            this.loading = true;
                            cancelQuit(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message.success("操作成功");
                                    this.handleDialogClose()
                                    this.$emit("success-callback");
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {
                        });
            },
            // 信息确认
            handleClickConfirmProfile() {
                const postData = {
                    user_id: this.user_id,
                };
                this.loading = true;
                ConfirmProfileEdit(postData).then((res) => {
                    if (res.code === 200) {
                        this.$message.success("操作成功");
                        this.handleDialogClose()
                        this.$emit("success-callback");
                    }
                    this.loading = false;
                });
            },
            // 发送接口
            handleSubmit() {
                console.log("发送接口");
            },

            //接收子组件参数
            summitFormData(customForm) {
                if (this.profile_edit) {
                    // 被邀请之后 编辑过的
                    const data = {
                        edit_id: this.edit_id,
                        edited_data: customForm,
                    };
                    UpdateProfileEdit(data).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("编辑成功");
                            this.$emit("success-callback");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else {
                    const data = {
                        ...customForm,
                        user_id: this.user_id,
                    };
                    editUser(data).then((res) => {
                        if (res.code === 200) {
                            // this.$message.success("编辑成功");
                            this.$emit("success-callback");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },

            // 发送短信，只能发送一次，下次进来页面还可发送
            handleClickSend() {
                SendLoginSMS({user_id: this.user_id}).then((res) => {
                    if (res.code === 200) {
                        this.$message({
                            type: "success",
                            message: res.message,
                            duration: 1500,
                            onClose: () => {
                                this.isSendSms = true;
                            },
                        });
                    }
                });
            },
        },
    };
</script>
<style lang="scss">
    .tag-label {
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-left: 8px;

        &.tag-label-unregistered {
            background-color: rgba(255, 141, 26, 0.1);
            color: rgba(255, 141, 26, 1);
        }

        &.tag-label-PendingJoin {
            background-color: rgba(240, 170, 50, 0.1);
            color: rgba(240, 170, 50, 1);
        }

        &.tag-label-pendingOffice {
            background-color: rgba(228, 65, 68, 0.1);
            color: rgba(228, 65, 68, 1);
        }
    }

    .custom-department-tooltip-dialog {
        .el-dialog__body {
            min-height: 110px;
            padding-bottom: 0 !important;

            .el-button--text {
                padding: 0;
                border: 0;
            }
        }
    }

    .dialog-txt-tip {
        .link-label_btn {
            padding: 0;
        }
    }
</style>
